package team.platforma.multiplatform_material_extension.ui.dialog.utils

import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import kotlinx.browser.window

actual fun Modifier.keyBoardPadding(keyBoard: Int): Modifier {
    return this.padding(
        start = 32.dp,
        end = 32.dp,
        top = 32.dp,
        bottom = keyBoard.dp + 32.dp
    )
}

@Composable
actual fun observeKeyBoard(int: (Int) -> Unit) {
    val visualViewport = js("window.visualViewport")
    if (visualViewport != undefined) {
        visualViewport.addEventListener("resize") {
            val currentHeight = js("window.innerHeight").unsafeCast<Int>()
            val viewportHeight = js("visualViewport.height").unsafeCast<Double>().toInt()
            val keyboardHeight = (currentHeight - viewportHeight).coerceAtLeast(0)
            int(keyboardHeight)
        }
    } else {
        // Fallback для браузеров без visualViewport
        val initialHeight = js("window.innerHeight").unsafeCast<Int>()
        window.addEventListener("resize", {
            val currentHeight = js("window.innerHeight").unsafeCast<Int>()
            val keyboardHeight = (initialHeight - currentHeight).coerceAtLeast(0)
            int(keyboardHeight)
        })
    }
}